import {Component, Input} from '@angular/core';

/**
 * A component that renders an SVG icon for "delete"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */
@Component({
    selector: 'app-icon-delete',
    templateUrl: './icon-delete.component.html',
    styleUrls: ['./icon-delete.component.scss'],
    standalone: false
})
export class IconDeleteComponent {
  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;
}
